export const uniqueCI = (xs: string[]) => {
    const seen = new Set<string>();
    const out: string[] = [];
    for (const x of xs) {
        const k = x.toLowerCase();
        if (!seen.has(k)) { seen.add(k); out.push(x); }
    }
    return out;
};
